import ACL_RELATIONSHIPS from "acl-relationships";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import withRoleCheck from "components/hocs/withRoleCheck";
import { useRevalidateMxDomain } from "hooks/useMxDomainsTable";

const RevalidateButton = ({ mxDomain }) => {
  const revalidate = useRevalidateMxDomain();

  return (
    <Button
      variant="outline"
      size="sm"
      aria-label={`Re-validate ${mxDomain.domain}`}
      disabled={revalidate.isPending}
      onClick={() => revalidate.mutate(mxDomain.id)}
    >
      {revalidate.isPending && <Spinner />}
      Re-validate
    </Button>
  );
};

export const RevalidateMxDomainButton = withRoleCheck(RevalidateButton, [
  ACL_RELATIONSHIPS.mxDomains.revalidate,
]);
